<template>
  <div 
    class="--shortcut"
    @click="open"
    :title="url"
    >
    <div 
      class="icon"
      :style="{
        'background-color': backgroundIconColor,
        'color': iconColor
      }"  
      >
      <slot name="icon"></slot>
    </div>
    <div class="--body">
      <div class="--title">
        <slot name="title"></slot>
      </div>
      <div class="--subtitle">
        <slot name="subtitle"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
const _router = useRouter()

const props = defineProps({
  url: {
    type: String,
    default: ''
  },
  backgroundIconColor: {
    type: String,
    default: '#fff'
  },
  iconColor: {
    type: String,
    default: '#222'
  },
})

const open = () => {
  console.log('open', props.url)
  if(props.url) {
    _router.push(props.url)
  }
}

</script>

<style scoped >
.--shortcut {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #ccc;
  display: grid;
  grid-template-columns:  40px 1fr;
  align-items: center;
  gap: 10px;
  padding: 10px;
  cursor: pointer;
  .title,
  .subtitle {
    padding: 10px 25px
  }
  .--body {
    display: flex;
    flex-direction: column;
    line-height: 1;
    .subtitle {
      background-color: #FCFCFC;
    }
    .--title {
      font-weight: 800;
    }
  }
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    height: 40px;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
  }
}
</style>